import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';

import { Spinner } from '@/components/common';
import ScheduleBasemapSelector from '@/components/SchedulePage/ScheduleMap/ScheduleBasemapSelector';
import {
  getStoredBasemapId,
  setStoredBasemapId,
} from '@/components/SchedulePage/ScheduleMap/helpers/basemaps';
import ScheduleLeafletMap from '@/components/SchedulePage/ScheduleMap/ScheduleLeafletMap';
import ScheduleMapFilters from '@/components/SchedulePage/ScheduleMap/ScheduleMapFilters';
import classes from '@/components/SchedulePage/ScheduleMap/style.module.scss';

const ScheduleMapComponent = ({
  filters,
  layers,
  inspectorOptions,
  markers,
  polylines,
  coordinatesLoading,
  isVisible,
  scheduleDate,
  mapFocusRequest,
  selectedMapOrderId,
  onFilterChange,
  onLayerToggle,
  onInspectorToggle,
  onSelectAllInspectors,
  onOrderMarkerClick,
}) => {
  const [activeBasemapId, setActiveBasemapId] = useState(getStoredBasemapId);

  const handleSelectBasemap = useCallback(newId => {
    setActiveBasemapId(newId);
    setStoredBasemapId(newId);
  }, []);

  return (
    <div className={classes.mapArea}>
      <ScheduleMapFilters
        filters={filters}
        layers={layers}
        inspectorOptions={inspectorOptions}
        onFilterChange={onFilterChange}
        onLayerToggle={onLayerToggle}
        onInspectorToggle={onInspectorToggle}
        onSelectAllInspectors={onSelectAllInspectors}
      />

      <div className={classes.mapCanvas}>
        <ScheduleBasemapSelector
          activeBasemapId={activeBasemapId}
          onSelectBasemap={handleSelectBasemap}
        />

        <ScheduleLeafletMap
          activeBasemapId={activeBasemapId}
          markers={markers}
          polylines={polylines}
          focusRequest={mapFocusRequest}
          selectedOrderId={selectedMapOrderId}
          isVisible={isVisible}
          scheduleDate={scheduleDate}
          onOrderMarkerClick={onOrderMarkerClick}
        />

        {coordinatesLoading && (
          <div className={classes.loadingOverlay} aria-live="polite">
            <Spinner />
            <span>Localizando endereços...</span>
          </div>
        )}
      </div>
    </div>
  );
};

ScheduleMapComponent.propTypes = {
  filters: PropTypes.object.isRequired,
  layers: PropTypes.objectOf(PropTypes.bool).isRequired,
  inspectorOptions: PropTypes.array.isRequired,
  markers: PropTypes.arrayOf(PropTypes.object).isRequired,
  polylines: PropTypes.arrayOf(PropTypes.object).isRequired,
  coordinatesLoading: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  scheduleDate: PropTypes.string,
  mapFocusRequest: PropTypes.shape({
    orderId: PropTypes.string.isRequired,
    position: PropTypes.arrayOf(PropTypes.number).isRequired,
  }),
  selectedMapOrderId: PropTypes.string,
  onFilterChange: PropTypes.func.isRequired,
  onLayerToggle: PropTypes.func.isRequired,
  onInspectorToggle: PropTypes.func.isRequired,
  onSelectAllInspectors: PropTypes.func.isRequired,
  onOrderMarkerClick: PropTypes.func.isRequired,
};

ScheduleMapComponent.defaultProps = {
  scheduleDate: null,
  mapFocusRequest: null,
  selectedMapOrderId: null,
};

export default React.memo(ScheduleMapComponent);
